<template>
  <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space ">
    <!-- Order Details -->
    <tab-pane>
      <template slot="label">
        <i class="fa fa-microscope" />
      </template>

      <!-- Status Timeline-->
      <div class="col-md-12 mt-3" v-if="labOrderStatus && labOrderStatus.length > 0">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Status") }}</h6>
        </div>
        <div class="col-md-12">
          <el-timeline>
            <el-timeline-item v-for="(status, index) in labOrderStatus" size='large' :key="index" icon="el-icon-check" :timestamp="getSampleCollectionDatetime(status.timestamp)">
              {{getLabOrderStatus(status.status)}}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

      <!-- Health Package -->
      <div v-if="laborder && laborder.healthPackage" class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Health Package") }}</h6>
        </div>
        <div>
          <div class="labtest-card">
            <card>
              <div class="">
                <p>{{ laborder.healthPackage.name }}</p>
              </div>
            </card>
          </div>
        </div>
      </div>
      <!-- Sample Collection Passcode -->
      <div v-if="laborder && laborder.otp && laborder.otp.sampleCollection && laborder.sampleCollectionHome" class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Sample Collection Passcode") }}</h6>
        </div>
        <card>
          <div class="laborder-passcode">
            {{laborder.otp.sampleCollection}}
          </div>
        </card>
      </div>

      <!-- Sample Deposit Passcode -->
      <div v-if="laborder && laborder.otp && laborder.otp.sampleDeposit && !laborder.sampleCollectionHome" class="col-md-12 mt-3">
        <div class="col-md-12 ">
          <h6>{{ $t("message.Sample Deposit Passcode") }}</h6>
        </div>
        <card>
          <div class="laborder-passcode">
            {{laborder.otp.sampleDeposit}}
          </div>
        </card>
      </div>

      <!-- Lab Details -->
      <div class="col-md-12 pb-5" v-if="lab">
        <div class="col-md-12">
          <h6>{{ $t("message.Lab Details") }}</h6>
        </div>
        <card>
          <div class="col-md-12 pl-0">
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-microscope"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0">
                <span>{{lab.name}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1 col-3 text-center">
                <span>
                  <i class="fa fa-map-marker-alt"></i>
                </span>
              </div>
              <div class="col-md-8 col-9 pl-0" v-if="lab.location && lab.location.addressDetails">
                <span>{{lab.location.addressDetails.address}}</span>
              </div>
            </div>

            <div class="col-12 text-center" v-if="lab && lab.location && lab.location.addressDetails && lab.location.addressDetails.geolocation && lab.location.addressDetails.geolocation.coordinates">
              <n-button type="primary" class="btn-padding light mr-2" round @click.native="navigate()" simple>
                <i slot="label" class="fa fa-route pr-2"></i>
                {{  $t("message.Navigate") }}
              </n-button>
            </div>
          </div>

        </card>
      </div>

    </tab-pane>

    <!-- Reports -->
    <tab-pane label="lab-reports" v-if="laborder && reports && reports.length > 0">
      <template slot="label">
        <i class="fas fa-file-medical" />
      </template>
      <div style="height:100%;">
        <div class="col-12 list-wrapper" style="height:100%;">
          <file-card :files="reports" :show-add-button="false" :laborder="laborder" :patient-id="laborder.patient.patientId" :delete-control="false" :upload-control="false"></file-card>
        </div>
        <n-pagination v-if="reportsPagination.totalPages > 1" :page-count="reportsPagination.totalPages" v-model="reportsPagination.pageNumber"></n-pagination>
      </div>
    </tab-pane>

  </tabs>

</template>


<script>
import { TabPane, Tabs } from "src/components";
import FileCard from "../components/FileCard.vue";

export default {
  name: "viewScheduledHealthCheckupRequest",
  components: {
    TabPane,
    Tabs,
    FileCard,
  },
  data() {
    return {
      laborder: null,
      SAMPLE_COLLECTED: false,
      SAMPLE_DEPOSITED: false,
      REPORT_UPLOADED: false,
      lab: null,
      reportsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      reports: [],
    };
  },
  async mounted() {
    try {
      this.laborder = await this.$store.dispatch("getLabOrderById", {
        id: this.$store.state.scheduledRequest._id,
      });
      console.log(this.laborder);
      if (this.laborder.status) {
        this.laborder.status.forEach((status) => {
          if (status.status == "Sample Collected") {
            this.SAMPLE_COLLECTED = true;
          } else if (status.status == "Sample Deposited") {
            this.SAMPLE_DEPOSITED = true;
          } else if (status.status == "Report Uploaded") {
            this.REPORT_UPLOADED = true;
          }
        });
      }
      if (this.laborder.lab) {
        let response = await this.$store.dispatch(
          "getEndpointDetails",
          this.laborder.lab
        );
        this.lab = response;
      }
    } catch (e) {
      console.error(e);
    }
    await this.getReports();
    this.$forceUpdate();
  },
  computed: {
    labOrderStatus() {
      if (this.laborder && this.laborder.status) {
        let arr = this.laborder.status.filter((status) => {
          return status.status != "Blocked";
        });
        return arr;
      } else {
        return [];
      }
    },
  },
  methods: {
    async getReports() {
      try {
        if (
          this.laborder &&
          this.laborder.patient &&
          this.laborder.patient.patientId
        ) {
          var query = {
            laborderId: this.laborder._id,
            patientId: this.laborder.patient.patientId,
          };

          let response = await this.$store.dispatch("getFiles", {
            query,
            pageNumber: this.reportsPagination.pageNumber,
            pageSize: "5",
          });

          this.reports = response.data;
          this.reportsPagination.totalPages = response.totalPages;
        }
      } catch (err) {
        console.log(err);
      }
    },
    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    getSampleCollectionDatetime(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },
    getLabOrderStatus(status) {
      let msgVal = status;
      if (status == "Created") {
        msgVal = this.$t("message.Created");
      }
      if (status == "Accepted") {
        msgVal = this.$t("message.Accepted");
      }
      if (status == "Sample Collected") {
        msgVal = this.$t("message.Sample collected");
      }
      if (status == "Sample Deposited") {
        msgVal = this.$t("message.Sample deposited");
      }
      if (status == "Report Uploaded") {
        msgVal = this.$t("message.Report uploaded");
      }
      return msgVal;
    },
    navigate() {
      let geocoords = "";

      let coordinates =
        this.lab.location.addressDetails.geolocation.coordinates;
      geocoords = coordinates[1] + "," + coordinates[0];

      if (device.platform == "iOS") {
        window.open("maps://?q=" + geocoords, "_system");
      } else {
        window.open("geo:0,0?q=" + geocoords, "_system");
      }
    },
  },
};
</script>
<style scoped>
/deep/.tab-content {
  height: calc(100% - 68px);
  /* for fixed buttons from bottom */
  position: relative;
}
.content > div {
  height: 100%;
}
.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}
.status-update-buttons {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.el-timeline {
  padding-left: 2em;
}

/deep/.el-timeline-item__icon {
  color: #18ce0f;
}

/deep/.el-timeline-item__node {
  background: white;
  border: solid 1px #18ce0f;
  padding: 0.8em;
  left: -7px;
}
/deep/.el-timeline-item {
  padding-bottom: 30px;
}

/deep/.el-timeline-item__timestamp {
  font-size: 11px;
}
.laborder-passcode {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5em;
}
</style>
